import React from 'react';
import PropTypes from 'prop-types';

export default function StepStatic({ step, iconClassName, wrapperClassName }) {
  return (
    <div className={`selected-topic icon-with-text ${wrapperClassName}`}>
      <div className="icon-bg bg-tertiary-1000">
        <i className={iconClassName} />
      </div>

      <div className="text-content">
        <div className="mb-1">{step.title}</div>

        <small>{step.description}</small>
      </div>
    </div>
  );
}

StepStatic.propTypes = {
  step: PropTypes.object.isRequired,
  iconClassName: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
};

StepStatic.defaultProps = {
  wrapperClassName: '',
};
